import API from './api'

export const getSellers = async (text = '') => {
  try {
    const response = await API.get(`employees/sellers/search${text ? `?text=${text}` : ''}`)
    return response?.data?.results || []
  } catch (err) {
    console.error('[getSellers] Erro ao buscar vendedores:', err.message)
    return []
  }
}

export const postSeller = async (id, sellerId) => {
  const results = await API.post(
    `service-order/appointment/${id}/update-seller`,
    {
      sellerId,
    },
  )

  return results
}
